//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ORDER, ORDER_TX, ORDER_TYPE, ORDER_TYPE_TX } from './_const'
import CommonSelect from '@/components/form/common_select'
import DecoratorTip from './_decorator_tip'
const orders = [
    {
        text: '楼栋顺序排序',
        value: ORDER.ASC,
        type: ORDER_TYPE.BLOCK_NO
    },
    {
        text: '清水总价从高到低',
        value: ORDER.DESC,
        type: ORDER_TYPE.WATER_PRICE
    },
    {
        text: '清水总价从低到高',
        value: ORDER.ASC,
        type: ORDER_TYPE.WATER_PRICE
    },
    {
        text: '清水单价从高到低',
        value: ORDER.DESC,
        type: ORDER_TYPE.SQUARE_PRICE
    },
    {
        text: '清水单价从低到高',
        value: ORDER.ASC,
        type: ORDER_TYPE.SQUARE_PRICE
    },
    {
        text: '面积从大到小',
        value: ORDER.DESC,
        type: ORDER_TYPE.AREA
    },
    {
        text: '面积从小到大',
        value: ORDER.ASC,
        type: ORDER_TYPE.AREA
    }
]
const getDefault = () => {
    return {
        orders: orders,
        selected_block: 0,
        selected_unit: 0,
        selected_decorate_type: 0,
        selected_status: 0,
        selected_price: '',
        selected_order: '',
        show_block_picker: false,
        show_unit_picker: false,
        show_decorate_picker: false,
        show_price_picker: false,
        show_order_picker: false,
        show_decorate_tip: true,
        show_status_picker: false,
        type: ''
    }
}
export default {
    data () {
        return getDefault()
    },
    onLoad () {
        const { type } = this.$route.query
        Object.assign(this.$data, getDefault())
        this.type = type
    },
    computed: {
        can_show_decorator_tip () {
            return !this.type && this.show_decorate_tip && this.house_decorate_prices && this.house_decorate_prices.length && this.decoration_type != '清水'
        },
        show_unit () {
            return this.units.length && this.block_no
        },
        show_decorate_type () {
            return this.decoration_types && this.decoration_types.length > 1
        },
        show_decorate_price () {
            return this.house_decorate_prices && this.house_decorate_prices.length && this.decoration_type != '清水'
        },
        show_status () {
            return this.status_opts && this.status_opts.length > 1
        },
        filter_2_cols () {
            return !this.show_unit && !this.show_decorate_type && !this.show_decorate_price && !this.show_status && !this.decoration_price_tmp_empty
        },
        show_tip() {
            return (this.layout_image.area && this.layout_image.area !== '') || (this.layout_image.layout_no && this.layout_image.layout_no)
        }
    },
    methods: {
        call () {
            if (this.decoration_price_tmp_empty) {
                return
            }
            this.$emit('call')
        },
        changeBlock (index) {
            this.selected_block = index
            this.selected_unit = 0
            this.$emit('changeFilter', {
                block_no: this.block_nos[index].value,
                unit: ''
            })
        },
        changeUnit (index) {
            this.selected_unit = index
            this.$emit('changeFilter', {
                unit: this.units[index].value
            })
        },
        changeDecorate (index) {
            this.selected_decorate_type = index
            this.$emit('changeFilter', {
                decoration_type: this.decoration_types[index].value
            })
        },
        changePrice (index) {
            this.selected_price = index
            this.$emit('changeDecoratePrice', this.house_decorate_prices[index].value)
        },
        changeOrder (index) {
            this.selected_order = index
            this.$emit('changeOrder', this.orders[index])
        },
        changeStatus (index) {
            this.selected_status = index
            this.$emit('changeFilter', {
                status: this.status_opts[index].value
            })
        },
        toggleStatusPicker () {
            this.show_status_picker = !this.show_status_picker
            this.$emit('showSelect', this.show_status_picker)
        },
        toggleBlockPicker () {
            this.show_block_picker = !this.show_block_picker
            this.$emit('showSelect', this.show_block_picker)
        },
        toggleUnitPicker () {
            this.show_unit_picker = !this.show_unit_picker
            this.$emit('showSelect', this.show_unit_picker)
        },
        toggleDecoratePicker () {
            this.show_decorate_picker = !this.show_decorate_picker
            this.$emit('showSelect', this.show_decorate_picker)
        },
        toggleDecoratePrice () {
            this.show_price_picker = !this.show_price_picker
            this.$emit('showSelect', this.show_price_picker)
        },
        toggleOrderPicker () {
            this.show_order_picker = !this.show_order_picker
            this.$emit('showSelect', this.show_order_picker)
        },
        removeScreen() {
            this.$emit('removeScreen')
        }
    },
    props: {
        decoration_price_tmp_empty: Boolean,
        block_nos: {
            type: Array
        },
        units: {
            type: Array
        },
        decoration_types: {
            type: Array
        },
        house_decorate_prices: {
            type: Array
        },
        block_no: {
            type: [Number, String]
        },
        decoration_type: {
            type: String
        },
        unit: {
            type: String
        },
        status: {
            type: String
        },
        status_opts: {
            type: Array
        },
        layout_image: {
            type: Object
        }
    },
    components: {
        CommonSelect,
        DecoratorTip
    }
}
